module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/rec_bg-m-7155b59cbc1b0d50911a1c555360a0dd.jpg";